/*globals $*/
'use strict'; let didScroll;

const getSvg = () => import("./external/functions/svg.js");
const getScrollTo = () => import("./external/functions/scroll_to.js");
const getGSAP = () => import("./external/functions/gsap.js");
const getReveal = () => import("./external/functions/reveal");
import { initSwiperProject, initPressScrollSnap, initHomeHeroSwiper } from "./external/functions/swiper";

//import AOS from 'aos';
//window.addEventListener('load', AOS.refresh);
//window.onload = function () { AOS.init(); };

// MOBILE MENU DRAWER LOGIC
document.addEventListener("DOMContentLoaded", function () {

   // 48h Session tracking for Home intro skip: If user is on any internal page, mark intro as seen
   try {
      const isHome = document.querySelector('.s-home-hero') !== null;
      if (!isHome) {
         localStorage.setItem('kx_intro_seen', Date.now().toString());
      }
   } catch (e) {}

   // PROJECT INFO TOGGLE LOGIC (+INFO / -INFO OVERLAY - MOBILE ONLY)
   document.addEventListener('click', function (e) {
      const toggleBtn = e.target.closest('.js-project-info-toggle');
      if (toggleBtn) {
         const mobSection = toggleBtn.closest('.s-single-project-mobile');
         if (mobSection) {
            e.preventDefault();
            const isOpen = mobSection.classList.toggle('is-info-open');
            mobSection.querySelectorAll('.js-project-info-toggle').forEach(tBtn => {
               const label = tBtn.querySelector('.js-info-toggle-text') || tBtn.querySelector('span') || tBtn;
               if (label) label.textContent = isOpen ? '- INFO' : '+ INFO';
               tBtn.setAttribute('aria-expanded', isOpen.toString());
            });
         }
         return;
      }

      // CLICK OUTSIDE TO CLOSE +INFO OVERLAY
      const openMobSection = document.querySelector('.s-single-project-mobile.is-info-open');
      if (openMobSection) {
         const isClickInsideContent = e.target.closest('.js-info-overlay-track');
         if (!isClickInsideContent) {
            openMobSection.classList.remove('is-info-open');
            openMobSection.querySelectorAll('.js-project-info-toggle').forEach(tBtn => {
               const label = tBtn.querySelector('.js-info-toggle-text') || tBtn.querySelector('span') || tBtn;
               if (label) label.textContent = '+ INFO';
               tBtn.setAttribute('aria-expanded', 'false');
            });
         }
      }

      // LLEGIR MÉS / LLEGIR MENYS EXPAND LOGIC
      const moreBtn = e.target.closest('.js-llegir-more-btn');
      if (moreBtn) {
         e.preventDefault();
         const textBlock = moreBtn.closest('.js-info-text-block');
         if (textBlock) {
            textBlock.classList.add('is-text-expanded');
         }
      }

      const lessBtn = e.target.closest('.js-llegir-less-btn');
      if (lessBtn) {
         e.preventDefault();
         const textBlock = lessBtn.closest('.js-info-text-block');
         if (textBlock) {
            textBlock.classList.remove('is-text-expanded');
         }
      }
   });

   // MOBILE SINGLE PROJECT: STICKY "SCROLL ->" UNSTICK AT LAST PHOTO
   const initMobileScrollIndicator = () => {
      const galleryRows = document.querySelectorAll('.s-single-project-mobile__gallery-row');
      galleryRows.forEach(galleryRow => {
         const mobSection = galleryRow.closest('.s-single-project-mobile');
         if (!mobSection) return;

         const scrollIndicator = mobSection.querySelector('.s-single-project-mobile__scroll-fixed');
         const lastPhoto = mobSection.querySelector('.s-single-project-mobile__photo-item--last');
         if (!scrollIndicator || !lastPhoto) return;

         let ticking = false;

         const updateScrollPos = () => {
            const lastPhotoRect = lastPhoto.getBoundingClientRect();
            const rowRect = galleryRow.getBoundingClientRect();

            // When the last photo's right edge crosses the container's right edge,
            // shift the scroll indicator to the left with it:
            if (lastPhotoRect.right < rowRect.right) {
               const shiftLeft = lastPhotoRect.right - rowRect.right;
               scrollIndicator.style.transform = `translate3d(${shiftLeft}px, 0, 0)`;
               scrollIndicator.style.visibility = lastPhotoRect.right < 0 ? 'hidden' : 'visible';
            } else {
               scrollIndicator.style.transform = 'translate3d(0, 0, 0)';
               scrollIndicator.style.visibility = 'visible';
            }
            ticking = false;
         };

         galleryRow.addEventListener('scroll', () => {
            if (!ticking) {
               window.requestAnimationFrame(updateScrollPos);
               ticking = true;
            }
         }, { passive: true });

         updateScrollPos();
         window.addEventListener('resize', updateScrollPos, { passive: true });
      });
   };

   initMobileScrollIndicator();

   const menuToggles = document.querySelectorAll('.js-menu-toggle, .js-menu-close');
   const drawerWrapper = document.querySelector('.js-header-drawer-wrapper');

   if (menuToggles.length > 0 && drawerWrapper) {
      menuToggles.forEach(toggle => {
         toggle.addEventListener('click', (e) => {
            e.preventDefault();
            const isOpen = drawerWrapper.classList.contains('is-open');
            if (isOpen) {
               drawerWrapper.classList.remove('is-open');
               drawerWrapper.setAttribute('aria-hidden', 'true');
               document.body.classList.remove('no-scroll', 'is-menu-open');
            } else {
               drawerWrapper.classList.add('is-open');
               drawerWrapper.setAttribute('aria-hidden', 'false');
               document.body.classList.add('no-scroll', 'is-menu-open');

               getGSAP().then(gsapModule => {
                  gsapModule.initDrawerMenuReveal();
               });
            }
         });
      });
   }

   // FOOTER / HEADER LANGUAGE DROPDOWN TOGGLE
   const langToggles = document.querySelectorAll('.js-lang-toggle');
   if (langToggles.length > 0) {
      langToggles.forEach(btn => {
         btn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            const wrapper = btn.closest('.js-lang-wrapper') || btn.closest('.js-lang-switcher');
            if (wrapper) {
               const dropdown = wrapper.querySelector('.js-lang-dropdown') || wrapper.querySelector('.js-lang-list');
               if (dropdown) {
                  const isOpen = dropdown.classList.contains('is-open');
                  document.querySelectorAll('.js-lang-dropdown, .js-lang-list').forEach(d => d.classList.remove('is-open'));
                  if (!isOpen) {
                     dropdown.classList.add('is-open');
                     btn.setAttribute('aria-expanded', 'true');
                  } else {
                     btn.setAttribute('aria-expanded', 'false');
                  }
               }
            }
         });
      });

      document.addEventListener('click', () => {
         document.querySelectorAll('.js-lang-dropdown, .js-lang-list').forEach(d => d.classList.remove('is-open'));
      });
   }

   const loadModuleOnIntersection = (selector, importFunction, initFunction) => {
      const elements = document.querySelectorAll(selector);
      if (elements.length > 0) {
         let moduleLoaded = false;
         const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
               if (entry.isIntersecting && !moduleLoaded) {
                  moduleLoaded = true;
                  importFunction().then(module => {
                     module[initFunction]();
                  }).catch(error => {
                     console.error(`Error loading module for ${selector}:`, error);
                  });
                  elements.forEach(element => observer.unobserve(element));
               }
            });
         }, { rootMargin: '0px 0px -200px 0px' });

         elements.forEach(element => {
            observer.observe(element);
         });
      }
   };

   if (document.querySelectorAll('.js-hscroll').length > 0) {
      getGSAP().then(gsapModule => {
         gsapModule.initScrollHorizontal();
      });
   }

   if (document.querySelectorAll('.js-single-project').length > 0) {
      getGSAP().then(gsapModule => {
         gsapModule.initSingleProjectScroll();
         gsapModule.initAlignRelatedInfo();
      });
   }

   if (document.querySelectorAll('.s-archive-projects').length > 0) {
      getGSAP().then(gsapModule => {
         gsapModule.initArchiveProjectsParallax();
      });
   }

   if (document.querySelectorAll('.s-home-hero').length > 0) {
      getGSAP().then(gsapModule => {
         gsapModule.initHomeHeroScroll();
         if (document.querySelector('.js-zoom-stack-hero')) {
            gsapModule.initZoomStackHero();
         }
      });
   }

   if (document.querySelectorAll('.s-home-about').length > 0) {
      getGSAP().then(gsapModule => {
         gsapModule.initHomeAboutReveal();
      });
   }

   if (document.querySelectorAll('.s-home-about, .s-home-methodology, .s-home-how-we-work, .js-reveal-building').length > 0) {
      getGSAP().then(gsapModule => {
         gsapModule.initBuildingTextReveal();
      });
   }

   if (document.querySelectorAll('.s-home-quote__statement, .s-home-how-we-work__quote').length > 0) {
      getGSAP().then(gsapModule => {
         gsapModule.initHomeQuotesReveal();
      });
   }

   if (document.querySelectorAll('.s-about-wrapper, .s-about-hero').length > 0) {
      getGSAP().then(gsapModule => {
         gsapModule.initAboutSticky();
         gsapModule.initAboutAnimations();
         gsapModule.initAboutParagraphReveal();
      });
   }

   if (document.querySelectorAll('.s-press-archive, .s-press-card').length > 0) {
      initPressScrollSnap();
      getGSAP().then(gsapModule => {
         gsapModule.initPressAnimations();
      });
   }

   if (document.querySelectorAll('.s-contact, .js-kx-contact-svg').length > 0) {
      getGSAP().then(gsapModule => {
         gsapModule.initContactLogoAnimation();
      });
   }

   if (document.querySelectorAll('.s-archive-projects').length > 0) {
      getGSAP().then(gsapModule => {
         gsapModule.initProjectsArchiveAnimations();
      });
   }

   if (document.querySelectorAll('.js-pinned-hero:not(.s-home-hero)').length > 0) {
      getGSAP().then(gsapModule => {
         gsapModule.initHeroPinGrow();
      });
   }

   if (document.querySelectorAll('.s-hero-mobile').length > 0) {
      getGSAP().then(gsapModule => {
         gsapModule.initHeroMobileSlides();
         gsapModule.initHeroMobile();
      });
   }


   //LOAD SVG IF NEEDED
   if (document.querySelectorAll('.svg').length > 0) {
      getSvg().then(svgModule => {
         svgModule.prepareSvg();
      });
   }
   /*
   //LOAD Scroll to buttons
   if (document.querySelectorAll('.js-scroll-to').length > 0) {
      getScrollTo().then(scrolltoModule => {
         scrolltoModule.initScrollTo();
      });
   }

   */

   if (document.querySelectorAll('.s-project-swiper').length > 0) {
      initSwiperProject();
   }

   loadModuleOnIntersection(".js-reveal", getReveal, 'initReveal');

});